// extracted by mini-css-extract-plugin
export default {"container":"CareRecipientActivation_container__wiGuS"};